import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { MAX_LOGOS_IN_LIST } from '../../../../config/setup/setup';
import ThemeContext from '../../../../providers/ThemeProvider';
import CompanyCarousel from './CompanyCarousel';
import CompanyList from './CompanyList';
import ImageLogo from './ImageLogo';

const CompanyLogos = ({ deal }) => {
  const theme = useContext(ThemeContext);
  const isBussiness = deal.business && deal.business.image;
  const isBundleArray = deal.bundle && deal.bundle.children;

  if (!deal || !isBussiness) return null;

  const getLogoImages = () => {
    if (!isBundleArray) {
      return (
        <ImageLogo
          alt={deal.business.image.alt || ''}
          dealId={deal.business.id}
          item={deal.business.image}
          webAddress={deal.webAddress}
        />
      );
    }

    return deal.bundle.children.map((item, index) => (
      <ImageLogo
        alt={item?.image?.alt || ''}
        bundle
        dealId={deal.business.id}
        item={item.image}
        key={`logo_business_${deal.id}_${item.childId || ''}_${index}`}
        webAddress={
          item.image && item.image.link
            ? item.image.link
            : deal.webAddress || ''
        }
      />
    ));
  };

  const isCarousel =
    isBundleArray && deal.bundle.children.length > MAX_LOGOS_IN_LIST;

  return (
    <div className="deal-merchant-logo">
      {isCarousel ? (
        <CompanyCarousel deal={getLogoImages()} />
      ) : (
        <CompanyList deal={getLogoImages()} />
      )}
      <style jsx>{`
        .deal-merchant-logo {
          width: 100%;
        }
        @media (min-width: ${theme.breakpoints.mdUp}) {
          .deal-merchant-logo {
            width: 160px;
          }
        }
      `}</style>
    </div>
  );
};

CompanyLogos.propTypes = {
  deal: PropTypes.object,
};

CompanyLogos.defaultProps = {
  deal: {},
};

export default CompanyLogos;
